import { MainNavMenuAsButton, MainNavMenuLink } from "@compono/ui";

import { ShowIf, ShowIfAny } from "~/auth-layer";

import { SettingsOutline2Icon } from "../icons/SettingsOutline2Icon";

export const AdminNav = () => {
  return (
    <ShowIfAny
      allowedTo={[
        "organisations.edit",
        "applicationMessages.createTemplates",
        "isAbleToManageTags",
        "jobBoards.manageSubscription",
        "organisations.manageApiKeys",
        "organisations.manageHrIntegrations",
        "organisations.manageSso",
      ]}
    >
      <MainNavMenuAsButton icon={SettingsOutline2Icon} label="Settings">
        <ShowIf allowedTo="organisations.edit">
          <MainNavMenuLink href={`/account`} label="General" />
        </ShowIf>
        <ShowIf allowedTo="applicationMessages.createTemplates">
          <MainNavMenuLink
            href={`/message-templates`}
            label="Message templates"
          />
        </ShowIf>
        <ShowIf allowedTo="isAbleToManageTags">
          <MainNavMenuLink href={`/manage-tags`} label="Tag library" />
        </ShowIf>
        <ShowIf allowedTo="jobBoards.manageSubscription">
          <MainNavMenuLink
            href={`/job-board-integration`}
            label="Job board integration"
          />
        </ShowIf>
        <ShowIf allowedTo="organisations.manageApiKeys">
          <MainNavMenuLink href={`/employer-api`} label="API management" />
        </ShowIf>
        <ShowIf allowedTo="organisations.manageHrIntegrations">
          <MainNavMenuLink
            href={`/integrations`}
            label="Integration management"
            id="integrations"
          />
        </ShowIf>
        <ShowIf allowedTo="organisations.manageSso">
          <MainNavMenuLink href={`/sso`} label="SSO" id="sso" />
        </ShowIf>
      </MainNavMenuAsButton>
    </ShowIfAny>
  );
};
